var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VueSignaturePad',{ref:"pad",attrs:{"width":_vm.width,"height":_vm.height,"options":_vm.padOptions,"custom-style":_vm.customStyle}})
}
var staticRenderFns = []

export { render, staticRenderFns }